
// 2. Luego tus estilos (para sobrescribir)
import "./src/styles/global.css";

// gatsby-browser.js
import AOS from "aos"
import "aos/dist/aos.css"

export const onClientEntry = () => {
  AOS.init({
    duration: 1000,
    once: true,
  });
};
